export const ORDER_CANCELLATION_START = "ORDER_CANCELLATION_START";
export const ORDER_CANCELLATION_SUCCESS = "ORDER_CANCELLATION_SUCCESS";
export const ORDER_CANCELLATION_FAILURE = "ORDER_CANCELLATION_FAILURE";
